import { useEffect, useRef } from 'react';

import { useAppDispatch } from '@/store/hooks';
import { SetLayoutGridState } from '@/store/slices/layout-grid/types';
import { setLayoutGridState } from '@/store/slices/layout-grid';

type TSetLayoutOptions = {
  preventUpdate?: boolean;
};

const useSetLayout = (layoutGridState: SetLayoutGridState, options?: TSetLayoutOptions) => {
  const dispatch = useAppDispatch();
  const preventUpdate = options?.preventUpdate;

  const hasSet = useRef(false);

  useEffect(() => {
    if (preventUpdate) return;
    if (hasSet.current) {
      return;
    }
    dispatch(setLayoutGridState(layoutGridState));
    hasSet.current = true;
  }, [dispatch, layoutGridState, preventUpdate]);
};

export default useSetLayout;
